import { useTranslation } from "react-i18next";

import { FormikProps } from "formik";

import { AssetDocumentArea, PendingDocumentMove } from "../../../../../api/ClientFileApi";
import { IncomeSectionCard } from "../../../income/components/income-section-card/IncomeSectionCard";
import { AssetsFormValues } from "../../AssetsView.types";
import { AssetUploadArea } from "../asset-upload-area/AssetUploadArea";
import { AssetYesNoQuestion } from "../asset-yes-no-question/AssetYesNoQuestion";

const SECTION = "clients.client.debtSettlement.assetInventory.assetsTab.realEstate";

interface Props {
  clientId: string;
  formik: FormikProps<AssetsFormValues>;
  onAddMove: (move: PendingDocumentMove) => void;
  onCancelMove: (documentId: string) => void;
}

export function RealEstateSection({ clientId, formik, onAddMove, onCancelMove }: Props) {
  const { t } = useTranslation();

  return (
    <IncomeSectionCard title={t(`${SECTION}.title`)}>
      <AssetYesNoQuestion
        formik={formik}
        field="hasDomesticRealEstate"
        label={t(`${SECTION}.hasDomesticRealEstate`)}
        detailsField="domesticRealEstateDetails"
        detailsLabel={t(`${SECTION}.domesticRealEstateDetails`)}
      >
        <AssetUploadArea
          clientId={clientId}
          formik={formik}
          area={AssetDocumentArea.DomesticRealEstate}
          label={t(`${SECTION}.domesticUpload`)}
          onAddMove={onAddMove}
          onCancelMove={onCancelMove}
        />
      </AssetYesNoQuestion>
      <AssetYesNoQuestion
        formik={formik}
        field="hasForeignRealEstate"
        label={t(`${SECTION}.hasForeignRealEstate`)}
        detailsField="foreignRealEstateDetails"
        detailsLabel={t(`${SECTION}.foreignRealEstateDetails`)}
      >
        <AssetUploadArea
          clientId={clientId}
          formik={formik}
          area={AssetDocumentArea.ForeignRealEstate}
          label={t(`${SECTION}.foreignUpload`)}
          onAddMove={onAddMove}
          onCancelMove={onCancelMove}
        />
      </AssetYesNoQuestion>
    </IncomeSectionCard>
  );
}
